import gql from 'graphql-tag'

export const GET_REPORT = gql`
  query GetReportPowerBI(
    $id_client: ID
    $id_site: ID
    $id_machine_type: ID
    $id_machine: ID
    $from: String!
    $to: String!
  ) {
    reportPowerBI(
      id_client: $id_client
      id_site: $id_site
      id_machine_type: $id_machine_type
      id_machine: $id_machine
      from: $from
      to: $to
    )
  }
`
export const GET_EXCEL = gql`
  query GetReportPowerBIExcel(
    $id_client: ID
    $id_site: ID
    $id_machine_type: ID
    $id_machine: ID
    $from: String!
    $to: String!
  ) {
    reportPowerBIExcel(
      id_client: $id_client
      id_site: $id_site
      id_machine_type: $id_machine_type
      id_machine: $id_machine
      from: $from
      to: $to
    )
  }
`
